import { useCallback, useState } from 'react'
import { ProgramManagementRow } from '../programManagement'

export const useProgramManagementDialog = () => {
  const [deleteConfirmation, setDeleteConfirmation] = useState(false)
  const [cancel, setCancel] = useState(false)
  const [projectSelection, setProjectSelection] = useState(false)
  const [projectSelectionParent, setProjectSelectionParent] =
    useState<ProgramManagementRow | null>(null)

  const openDeleteConfirmation = useCallback(() => {
    setDeleteConfirmation(true)
  }, [])

  const closeDeleteConfirmation = useCallback(() => {
    setDeleteConfirmation(false)
  }, [])

  const openCancel = useCallback(() => {
    setCancel(true)
  }, [])

  const closeCancel = useCallback(() => {
    setCancel(false)
  }, [])

  const openProjectSelection = useCallback(
    (parentRow: ProgramManagementRow) => {
      setProjectSelectionParent(parentRow)
      setProjectSelection(true)
    },
    []
  )

  const closeProjectSelection = useCallback(() => {
    setProjectSelection(false)
    setProjectSelectionParent(null)
  }, [])

  return {
    deleteConfirmation,
    openDeleteConfirmation,
    closeDeleteConfirmation,

    cancel,
    openCancel,
    closeCancel,

    projectSelection,
    projectSelectionParent,
    openProjectSelection,
    closeProjectSelection,
  }
}
